var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.$store.state.overlay,"z-index":"7","color":"primary","opacity":"0.4"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100","color":"white"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }